import { ConfirmDeletingElement } from './ConfirmDeletingElement.main';

export { ConfirmDeletingElement };
